<div class="m-4" *ngIf="eventSchedulesNotFound">
  <h2>Schedules not found</h2>
</div>

<div class="m-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="m-4" *ngIf="!eventSchedulesNotFound && (serverError === null)">

  <div class="form-group">
    <select class="custom-select w-auto"
            name="locationSelect"
            id="locationSelect"
            [(ngModel)]="locationId">
      <option *ngIf="locations === null"
              [ngValue]="null"
              disabled class="disabled">
        Loading...
      </option>
      <ng-container *ngIf="locations !== null">
        <option [ngValue]="null">All Locations</option>
        <option *ngFor="let location of locations"
                [ngValue]="location.id">
          {{ location.name }}
        </option>
      </ng-container>
    </select>

    <select class="custom-select w-auto ml-2"
            name="hideEnded"
            id="hideEnded"
            [(ngModel)]="hideEnded">
      <option [ngValue]="true">Hide Ended Schedules</option>
      <option [ngValue]="false">Show Ended Schedules</option>
    </select>

    <div class="float-right">
      <a class="btn btn-success"
         [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules/add'">
        Add Schedule
      </a>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th>Name</th>
        <th *ngIf="eventType?.schedule_type === ScheduleType.rolling">
          Roster
        </th>
        <th>Start Date</th>
        <th>End Date</th>
        <th *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
          Pricing Matrix
        </th>
        <th>Duration</th>
        <th>Location</th>
        <th>Time Slots</th>
        <th></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEventSchedules">
      <tr *ngFor="let schedule of getFilteredSchedules()">
        <td>
          {{ getScheduleNameString(schedule) }}
          <span *ngIf="!getScheduleNameString(schedule)" class="text-muted">None</span>
        </td>
        <td *ngIf="eventType?.schedule_type === ScheduleType.rolling">
          {{ schedule.roster_name }}
        </td>
        <td>{{ dateStringFromISO8601(schedule.start_date) }}</td>
        <td>
          <span *ngIf="schedule.end_date">{{ dateStringFromISO8601(schedule.end_date) }}</span>
          <span *ngIf="!schedule.end_date" class="text-muted">None</span>
        </td>
        <td *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
          {{ schedule.pricing_matrix_name }}
          <span *ngIf="!schedule.pricing_matrix_name" class="text-muted">None</span>
        </td>
        <td>{{ getDurationText(schedule.duration_minutes) }}</td>
        <td>{{ schedule.location_name }}</td>
        <td>
          <ng-container *ngFor="let timeSlot of eventTimeSlots[schedule.id].slice(0, 4); let last = last;">
            {{ timeStringFromISO8601TimeOnly(timeSlot.start_time) }},
            {{ getTimeSlotDaysText(timeSlot) }}
            <br *ngIf="!last">
          </ng-container>
          <i *ngIf="eventTimeSlots[schedule.id].length > 4">
            <br>
            + {{ eventTimeSlots[schedule.id].length - 4}}
            more time slot{{ eventTimeSlots[schedule.id].length > 5 ? 's' : '' }}
          </i>
          <span *ngIf="eventTimeSlots[schedule.id] && (eventTimeSlots[schedule.id].length === 0)"
                class="text-muted">
            None
          </span>
          <br>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.weekly">
            Time slots repeat weekly
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.biweekly">
            Time slots repeat every other week
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.monthlyFirstDays">
            Time slots repeat monthly, first day of the month
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.monthlySecondDays">
            Time slots repeat monthly, second day of the month
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.monthlyThirdDays">
            Time slots repeat monthly, third day of the month
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.monthlyFourthDays">
            Time slots repeat monthly, fourth day of the month
          </span>
          <span *ngIf="schedule.repetition === EventScheduleRepetition.monthlyLastDays">
            Time slots repeat monthly, last day of the month
          </span>
        </td>
        <td class="table-button-cell">
          <button class="btn btn-danger btn-sm float-right"
                (click)="removeSchedule(schedule)">
            Remove
          </button>
          <a class="btn btn-primary btn-sm float-right mr-2"
                [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules/' + schedule.id.toString()">
            Edit
          </a>
        </td>
      </tr>
      <tr *ngIf="getFilteredSchedules().length === 0">
        <td colspan="99" class="text-muted">No Schedules</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEventSchedules">
      <tr>
        <td colspan="99" class="text-muted">Loading...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="alert alert-info" role="alert" *ngIf="loadingEventSchedules">
    Loading schedules...
  </div>

  <div class="float-right">
    <a class="btn btn-primary"
       [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedule-exceptions'">
      Continue
    </a>
  </div>
  <a [routerLink]="['/events/setup/event-types']"
     [queryParams]="{status: eventType?.status}"
     class="btn btn-secondary">
    Back
  </a>

</div>
